import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import Dashboard from './pages/Dashboard';
import Ledgers from './pages/Ledgers';
import LedgerDetail from './pages/LedgerDetail';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import SoftyeExpenseTracker from './pages/SoftyeExpenseTracker';
import About from './pages/About';
import Features from './pages/Features';
import Contact from './pages/Contact';
import api from './api/axios';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));
  const [loading, setLoading] = useState(false);

  const handleLogin = async (email, password) => {
    try {
      const response = await api.post('/auth/login', { email, password });
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      setIsAuthenticated(true);
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  };

  const handleSignUp = async (name, email, password) => {
    try {
      const response = await api.post('/auth/register', { name, email, password });
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      setIsAuthenticated(true);
    } catch (error) {
      console.error('Sign up error:', error);
      throw error;
    }
  };

  return (
    <Router>
      <Routes>
        {/* Public routes without MainLayout (no sidebar) */}
        <Route path="/" element={!isAuthenticated ? <SoftyeExpenseTracker /> : <Navigate to="/dashboard" replace />} />

        <Route path="/login" element={!isAuthenticated ? <Login onLogin={handleLogin} /> : <Navigate to="/dashboard" replace />} />
        <Route path="/signup" element={!isAuthenticated ? <SignUp onSignUp={handleSignUp} /> : <Navigate to="/dashboard" replace />} />

        {/* SEO Pages - Public routes */}
        <Route path="/about" element={<About />} />
        <Route path="/features" element={<Features />} />
        <Route path="/contact" element={<Contact />} />

        {/* Protected routes with MainLayout (includes sidebar) */}
        <Route path="/dashboard" element={isAuthenticated ? <MainLayout><Dashboard /></MainLayout> : <Navigate to="/login" replace />} />
        <Route path="/ledgers" element={isAuthenticated ? <MainLayout><Ledgers /></MainLayout> : <Navigate to="/login" replace />} />
        <Route path="/ledgers/:ledgerId" element={isAuthenticated ? <MainLayout><LedgerDetail /></MainLayout> : <Navigate to="/login" replace />} />
        <Route path="/reports" element={isAuthenticated ? <MainLayout><Reports /></MainLayout> : <Navigate to="/login" replace />} />
        <Route path="/settings" element={isAuthenticated ? <MainLayout><Settings /></MainLayout> : <Navigate to="/login" replace />} />
        <Route path="*" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />} />
      </Routes>
    </Router>
  );
}

export default App;
